module.exports = __webpack_public_path__ + "img/Vector 51.91bd82c2.png";